// src/components/LanguageSwitcher.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Select = styled.select`
  position: fixed; /* ← Ajout crucial */
  top: 16px;
  right: 16px;
  z-index: 1000;
  padding: 6px 12px;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.secondaryText || '#ccc'};
  background: ${({ theme }) => theme.bg || '#fff'};
  color: ${({ theme }) => theme.text || '#000'};
  font-size: 14px;
  cursor: pointer;
  outline: none;
  appearance: none; /* masque la flèche par défaut (optionnel) */
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='${({ theme }) =>
    encodeURIComponent(theme.text || '#000')}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  background-size: 8px 10px;
  padding-right: 28px; /* pour laisser de la place à la flèche custom */

  &:hover {
    border-color: ${({ theme }) => theme.highlightColor || '#0077B5'};
  }
`;

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  return (
    <Select
      value={i18n.language}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      aria-label="Choisir la langue"
    >
      <option value="en">🇬🇧 EN</option>
      <option value="fr">🇫🇷 FR</option>
    </Select>
  );
};

export default LanguageSwitcher;